import axios from "axios";
import toast from "react-hot-toast";
import { MAIN_URL, getApiHeaders } from "../Configurations/Urls";

function handleAuthError(error) {
  if (error.response && error.response.status === 401) {
    toast.error("Session Expired!");
    window.location.href = "/login";
  }
}

export async function fetchEmailLogs(params) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/email-logs`, {
      headers: getApiHeaders(),
      params,
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function fetchEmailLogStats(params) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/email-logs/stats`, {
      headers: getApiHeaders(),
      params,
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function fetchEmailLogDetail(id, organizationId) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/email-logs/${id}`, {
      headers: getApiHeaders(),
      params: { organization_id: organizationId },
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function retryEmailLog(id, organizationId) {
  try {
    const response = await axios.post(
      `${MAIN_URL}/api/application/email-logs/${id}/retry`,
      { organization_id: organizationId },
      { headers: getApiHeaders() }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function exportEmailLogs(params, format = "csv") {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/email-logs/export`, {
      headers: getApiHeaders(),
      params: { ...params, format },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}
